import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { Heading, ModuleContainer, RichText } from "../../element";
import { FigureList } from "./FigureList";
export var TextContentBlockWithFigures = function(param) {
    var _content = param.content, content = _content.content, heading = _content.heading, figures = _content.figures, positionLabel = _content.positionLabel, rules = param.rules;
    var style = (rules === null || rules === void 0 ? void 0 : rules.textStyle) || Ui.RichTextStyle.Primary;
    return /*#__PURE__*/ _jsxs(ModuleContainer, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                content: heading,
                rules: {
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ _jsx(RichText, {
                content: content,
                rules: {
                    columns: [
                        [
                            12
                        ],
                        [
                            8,
                            "lg"
                        ]
                    ],
                    textStyle: {
                        hasSpacedParagraphs: true,
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ _jsx(FigureList, {
                content: figures,
                positionLabel: positionLabel
            })
        ]
    });
};
